import { Checkbox, Divider, Button, Spin } from "antd";
import CustomButton from "../../../../base/basicComponents/button";
import "./index.scss";
import VirtualList from "./VirtualList";
export const GetColumnCheckboxGroupFilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  filters,
  filterLoading,
}: any) => {
  const onChange = (event: any) => {
    setSelectedKeys(
      event.target.checked
        ? [...selectedKeys, event.target.value]
        : selectedKeys.filter((key: any) => key !== event.target.value)
    );
  };
  const clear = () => {
    setSelectedKeys([]);
    clearFilters();
  };
  const onOk = () => {
    confirm();
  };

  const selectAll = () => {
    const allValues = filters?.map((item: any) => item.value) || [];
    setSelectedKeys([...allValues]);
  };

  return (
    <Spin spinning={filterLoading} size="small" className="!max-h-none">
      <div className="filter-content">
        <div className="filter-content-body">
          <VirtualList
            items={filters}
            renderItem={(item: any) => (
              <div className="checkboxItem" key={item.value}>
                <Checkbox
                  checked={selectedKeys.includes(item.value)}
                  onChange={onChange}
                  value={item.value}
                  className="break-keep w-full"
                >
                  {item.text}
                </Checkbox>
              </div>
            )}
          />
        </div>
        <Divider />
        <div className="footer">
          <div className="footer-selectBtn">
            <Button
              type="link"
              size="small"
              disabled={filters?.length === 0 || selectedKeys?.length === filters.length}
              onClick={selectAll}
              data-testid="custom-filter-select-all-btn"
            >
              Select All
            </Button>
            <Button
              type="link"
              size="small"
              disabled={!selectedKeys?.length}
              onClick={clear}
              className="footer-ResetBtn"
              data-testid="custom-filter-reset-btn"
            >
              Reset
            </Button>
          </div>
          <CustomButton color="blue" size="tiny" onClick={onOk}>
            OK
          </CustomButton>
        </div>
      </div>
    </Spin>
  );
};
